export enum DeleteDialogType {
    Correspondence,
    Other
}
